"use client";

/**
 * First-party plugin — @mml/magic-wand.
 *
 * Phase 25-AB Task 15: wraps the Task 14 MagicWandModal as a plugin.
 * The panel slot is `magic-wand-modal` — the editor shell decides when
 * to mount the slot. The local `MagicWandSlot` is a thin stateful shell
 * that keeps the modal open while mounted; future tasks can swap it
 * with a properly-orchestrated trigger.
 */

import { useState } from "react";
import { MagicWandModal } from "@/components/magic-wand/MagicWandModal";
import type { StudioPlugin } from "@/plugin-sdk";

function MagicWandSlot() {
	const [open, setOpen] = useState(true);
	return <MagicWandModal open={open} onClose={() => setOpen(false)} />;
}

export const magicWandPlugin: StudioPlugin = {
	manifest: {
		id: "@mml/magic-wand",
		version: "0.1.0",
		name: "Magic Wand",
		description:
			"AI 매직 완드 — 50 wizards × 9 categories + combo recipes (AI-01 .. AI-50)",
		author: "makemonlab",
	},
	activate(api) {
		api.registerPanel({
			id: "magic-wand-modal",
			label: "Magic Wand",
			slot: "magic-wand-modal",
			render: () => <MagicWandSlot />,
		});
		api.registerCommand({
			id: "magic-wand.open",
			label: "Magic Wand 모달 열기",
			shortcut: "Ctrl+Alt+M",
			category: "Magic Wand",
			handler: () => {
				api.notify("Magic Wand modal triggered", "info");
			},
		});
		// Register a few representative wizards from the Task 14 catalog.
		// The full 50-wizard catalog still lives in wizards-data.ts;
		// the plugin layer exposes a stable surface for the editor to discover them.
		api.registerWizard({
			key: "ai-01",
			category: "analysis",
			name: "AI Cut Detect",
			description: "씬 자동 컷 감지",
			coinCost: 1,
			handler: async () => {
				api.notify("AI Cut Detect dispatched", "info");
			},
		});
		api.registerWizard({
			key: "ai-15",
			category: "subtitle",
			name: "Smart Caption",
			description: "AI 자막 자동 생성 + 스타일",
			coinCost: 2,
			handler: async () => {
				api.notify("Smart Caption dispatched", "info");
			},
		});
	},
};
